﻿/* ============================================================
   AZURA LUX — Main JavaScript
============================================================ */

(function () {
  'use strict';

  // ─ LOADER
  window.addEventListener('load', function () {
    setTimeout(function () {
      var loader = document.getElementById('loader');
      if (loader) loader.classList.add('done');
    }, 2200);
  });

  // ─ CURSOR
  if (window.matchMedia('(pointer:fine)').matches) {
    var dot = document.getElementById('cursorDot');
    var ring = document.getElementById('cursorRing');
    if (dot && ring) {
      var mx = 0, my = 0, rx = 0, ry = 0;
      document.addEventListener('mousemove', function (e) { mx = e.clientX; my = e.clientY; });
      (function tick() {
        rx += (mx - rx) * 0.12; ry += (my - ry) * 0.12;
        dot.style.left = mx + 'px'; dot.style.top = my + 'px';
        ring.style.left = rx + 'px'; ring.style.top = ry + 'px';
        requestAnimationFrame(tick);
      })();
      document.querySelectorAll('a,button,.prod-card,.pp-thumb,.ed-img-cell').forEach(function (el) {
        el.addEventListener('mouseenter', function () { document.body.classList.add('hovering'); });
        el.addEventListener('mouseleave', function () { document.body.classList.remove('hovering'); });
      });
    }
  }

  // ─ NAV SCROLL
  var nav = document.getElementById('nav');
  if (nav) {
    window.addEventListener('scroll', function () {
      nav.classList.toggle('solid', window.scrollY > 80);
    }, { passive: true });
  }

  // ─ SCROLL REVEAL
  var revealEls = document.querySelectorAll('.reveal');
  if ('IntersectionObserver' in window && revealEls.length) {
    var obs = new IntersectionObserver(function (entries) {
      entries.forEach(function (e) {
        if (e.isIntersecting) { e.target.classList.add('visible'); obs.unobserve(e.target); }
      });
    }, { threshold: 0.1 });
    revealEls.forEach(function (el) { obs.observe(el); });
  } else {
    revealEls.forEach(function (el) { el.classList.add('visible'); });
  }

  // ─ TOAST
  function showToast(msg) {
    var t = document.getElementById('toast');
    if (!t) return;
    t.textContent = msg;
    t.classList.add('show');
    setTimeout(function () { t.classList.remove('show'); }, 3200);
  }
  window.showToast = showToast;

  // ─ CART PANEL
  function openCart() {
    var p = document.getElementById('cartPanel'), s = document.getElementById('cartScrim');
    if (p) p.classList.add('open'); if (s) s.classList.add('active');
    document.body.style.overflow = 'hidden';
  }
  function closeCart() {
    var p = document.getElementById('cartPanel'), s = document.getElementById('cartScrim');
    if (p) p.classList.remove('open'); if (s) s.classList.remove('active');
    document.body.style.overflow = '';
  }
  var cartToggle = document.getElementById('cartToggle');
  var cartClose = document.getElementById('cartClose');
  var cartScrimEl = document.getElementById('cartScrim');
  if (cartToggle) cartToggle.addEventListener('click', function (e) { e.preventDefault(); openCart(); });
  if (cartClose) cartClose.addEventListener('click', closeCart);
  if (cartScrimEl) cartScrimEl.addEventListener('click', closeCart);

  function formatMoney(cents) {
    return (cents / 100).toFixed(2).replace('.', ',') + ' €';
  }

  function refreshCartPanel() {
    fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
      var countEl = document.getElementById('cartCount');
      if (countEl) countEl.textContent = cart.item_count;
      var body = document.getElementById('cartBody');
      var foot = document.getElementById('cartFoot') || document.querySelector('.cp-foot');
      if (!body) return;
      if (!cart.item_count) {
        body.innerHTML = '<p class="cp-empty">Ton panier est vide.<br><br>Explore la collection ✦</p>';
        if (foot) foot.style.display = 'none'; return;
      }
      body.innerHTML = cart.items.map(function (item, idx) {
        return '<div class="cp-item">' +
          '<img class="cp-item-img" src="' + item.image + '" alt="' + item.title + '">' +
          '<div class="cp-item-info">' +
          '<p class="cp-item-name">' + item.product_title + '</p>' +
          (item.variant_title && item.variant_title !== 'Default Title' ? '<p class="cp-item-variant">' + item.variant_title + '</p>' : '') +
          '<p class="cp-item-price">' + formatMoney(item.line_price) + '</p>' +
          '<div class="cp-qty">' +
          '<button class="cp-qty-btn" data-line="' + (idx + 1) + '" data-qty="' + (item.quantity - 1) + '">−</button>' +
          '<span>' + item.quantity + '</span>' +
          '<button class="cp-qty-btn" data-line="' + (idx + 1) + '" data-qty="' + (item.quantity + 1) + '">+</button>' +
          '</div></div>' +
          '<button class="cp-remove" data-line="' + (idx + 1) + '" data-qty="0">×</button>' +
          '</div>';
      }).join('');
      if (foot) {
        foot.style.display = 'block';
        var amtEl = foot.querySelector('.cp-total-amount');
        if (amtEl) amtEl.textContent = formatMoney(cart.total_price);
      }
      bindCartButtons();
    });
  }

  function bindCartButtons() {
    document.querySelectorAll('.cp-qty-btn,.cp-remove').forEach(function (btn) {
      btn.addEventListener('click', function () {
        fetch('/cart/change.js', {
          method: 'POST', headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ line: parseInt(this.dataset.line), quantity: parseInt(this.dataset.qty) })
        }).then(function () { refreshCartPanel(); });
      });
    });
  }

  document.addEventListener('submit', function (e) {
    var form = e.target;
    if (!form.classList.contains('prod-add-form') && form.getAttribute('action') !== '/cart/add') return;
    e.preventDefault();
    fetch('/cart/add.js', { method: 'POST', body: new FormData(form) })
      .then(function (r) { return r.json(); })
      .then(function (item) { refreshCartPanel(); openCart(); showToast('"' + item.product_title + '" ajouté au panier'); })
      .catch(function () { showToast('Erreur — veuillez réessayer'); });
  });

  var ppForm = document.getElementById('ppForm');
  if (ppForm) {
    ppForm.addEventListener('submit', function (e) {
      e.preventDefault();
      fetch('/cart/add.js', { method: 'POST', body: new FormData(ppForm) })
        .then(function (r) { return r.json(); })
        .then(function (item) { refreshCartPanel(); openCart(); showToast('"' + item.product_title + '" ajouté au panier'); });
    });
  }

  bindCartButtons();

  // ============================================================
  // NEWSLETTER POPUP
  // ─────────────────────────────────────────────────────────────
  // Le formulaire est un {% form 'customer' %} Shopify natif.
  // Shopify gère le CSRF et redirige vers /?nl=ok après succès.
  // Le JS détecte ?nl=ok au chargement et affiche le succès
  // dans le pop-up rouverts automatiquement.
  // ============================================================
  (function () {
    var NL_KEY   = 'azura_nl_done';
    var DELAY_MS = 30000;

    var popup    = document.getElementById('nlPopup');
    var scrim    = document.getElementById('nlScrim');
    var closeBtn = document.getElementById('nlPopupClose');
    var fields   = document.getElementById('nlPopupFields');
    var successEl = document.getElementById('nlSuccess');

    if (!popup) return;

    function openPopup() {
      popup.classList.add('open');
      scrim.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
    function closePopup() {
      popup.classList.remove('open');
      scrim.classList.remove('active');
      document.body.style.overflow = '';
    }
    function markDone() {
      try { localStorage.setItem(NL_KEY, '1'); } catch (e) { }
    }
    function isDone() {
      try { return !!localStorage.getItem(NL_KEY); } catch (e) { return false; }
    }

    // ─ CAS 1 : retour après soumission Shopify (?nl=ok)
    var params = new URLSearchParams(window.location.search);
    if (params.get('nl') === 'ok') {
      markDone();
      // Nettoyer l’URL sans rechargement
      var cleanUrl = window.location.pathname;
      window.history.replaceState({}, '', cleanUrl);
      // Ouvrir le popup en mode succès
      if (fields) fields.style.display = 'none';
      if (successEl) successEl.hidden = false;
      openPopup();
      // Fermer automatiquement après 4s
      setTimeout(closePopup, 4000);
      return; // ne pas planifier l’ouverture automatique
    }

    // ─ CAS 2 : déjà inscrit — ne pas afficher
    if (isDone()) return;

    // ─ CAS 3 : premier visiteur — ouvrir après délai
    setTimeout(openPopup, DELAY_MS);

    // Fermetures manuelles (ne marquent pas comme done)
    if (closeBtn) closeBtn.addEventListener('click', closePopup);
    if (scrim)    scrim.addEventListener('click', closePopup);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('open')) closePopup();
    });

  })();

  // ============================================================
  // PANIER ABANDONNÉ — Exit Intent + Mobile scroll-back
  // ============================================================
  (function () {
    var STORAGE_KEY = 'azura_ab_done';
    var MIN_TIME_MS = 8000;
    var pageStart   = Date.now();
    var triggered   = false;

    var popup      = document.getElementById('abPopup');
    var scrim      = document.getElementById('abScrim');
    var closeBtn   = document.getElementById('abPopupClose');
    var dismiss    = document.getElementById('abPopupDismiss');
    var itemsEl    = document.getElementById('abPopupItems');
    var totalEl    = document.getElementById('abPopupTotal');
    var totalAmtEl = document.getElementById('abPopupTotalAmount');

    if (!popup) return;

    var done = false;
    try { done = !!sessionStorage.getItem(STORAGE_KEY); } catch (e) { }
    if (done) return;

    function canTrigger() { return !triggered && (Date.now() - pageStart) > MIN_TIME_MS; }

    function openAbPopup() {
      if (triggered) return;
      fetch('/cart.js').then(function (r) { return r.json(); }).then(function (cart) {
        if (!cart.item_count) return;
        triggered = true;
        renderCartItems(cart);
        popup.classList.add('open'); scrim.classList.add('active');
        document.body.style.overflow = 'hidden';
      }).catch(function () { });
    }

    function closeAbPopup() {
      popup.classList.remove('open'); scrim.classList.remove('active');
      document.body.style.overflow = '';
      try { sessionStorage.setItem(STORAGE_KEY, '1'); } catch (e) { }
    }

    function renderCartItems(cart) {
      if (!itemsEl) return;
      var html = cart.items.slice(0, 3).map(function (item) {
        var img = item.image ? '<img class="ab-cart-img" src="' + item.image + '" alt="' + item.product_title + '">' : '';
        var variant = (item.variant_title && item.variant_title !== 'Default Title') ? '<p class="ab-cart-variant">' + item.variant_title + '</p>' : '';
        return '<div class="ab-cart-item">' + img + '<div class="ab-cart-info"><p class="ab-cart-name">' + item.product_title + '</p>' + variant + '<p class="ab-cart-price">' + formatMoney(item.line_price) + '</p></div></div>';
      }).join('');
      if (cart.items.length > 3) html += '<p style="font-size:11px;color:var(--muted);text-align:center;padding-top:.5rem">+ ' + (cart.items.length - 3) + ' autre(s)</p>';
      itemsEl.innerHTML = html;
      if (totalEl && totalAmtEl) { totalAmtEl.textContent = formatMoney(cart.total_price); totalEl.hidden = false; }
    }

    if (window.matchMedia('(pointer:fine)').matches) {
      document.addEventListener('mouseleave', function (e) {
        if (e.clientY <= 10 && canTrigger()) openAbPopup();
      });
    }

    // Déclencheur scroll-back mobile désactivé (trop intrusif sur mobile)

    if (closeBtn) closeBtn.addEventListener('click', closeAbPopup);
    if (dismiss)  dismiss.addEventListener('click',  closeAbPopup);
    if (scrim)    scrim.addEventListener('click',    closeAbPopup);
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && popup.classList.contains('open')) closeAbPopup();
    });

  })();

})();

